import { Component, OnInit, ViewChild, Inject, ElementRef } from '@angular/core';
import { MatDialogRef, MatTableDataSource, MatSort, MAT_DIALOG_DATA, MatDialog } from '@angular/material';

import { ApplicationConstants } from '../../providers/application-constants';
import { Utils } from '../../providers/utils';
import { QueryList } from '../../providers/query-list';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-cash-account-list',
  templateUrl: './cash-account-list.component.html',
  styleUrls: ['./cash-account-list.component.css']
})
export class CashAccountListComponent implements OnInit {

  public menu_item_id = '32';

  employee_list = [];
  private dp = [];

  displayedColumns = ['acct_number', 'name', 'sub_acct_name', 'baseline_amount', 'balance'];
  displayedColumns2 = ['acct_number', 'name', 'sub_acct_name', 'baseline_amount', 'balance'];
  dataSource = new MatTableDataSource(this.dp);
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild('TABLE') table: ElementRef;

  model = { 'table_name': 'sub_acct', 'acct_number': '', 'employee_no': '0', 'title': 'الحسابات النقدية' };

  Cash_Acct_List; Casher_Owner; Acct_No;

  constructor(private utils: Utils, private applicationConstants: ApplicationConstants,
    private queryList: QueryList, public translate: TranslateService) {
    this.getMessages(translate);
  }

  getMessages(translate) {

    translate.setDefaultLang(this.applicationConstants.user_lang);
    translate.use(this.applicationConstants.user_lang);

    translate.get('Cash_Acct_List').subscribe((res: string) => {
      this.Cash_Acct_List = res;
    });
    this.model['title'] = this.Cash_Acct_List;

    translate.get('Casher_Owner').subscribe((res: string) => {
      this.Casher_Owner = res;
    });

    translate.get('Acct_No').subscribe((res: string) => {
      this.Acct_No = res;
    });
  }

  ngOnInit() {
    let query = "SELECT `employee`.* FROM `employee`, `user` WHERE `user`.`status` = '1' AND " +
      "`user`.`is_counter` = '1' AND `user`.`employee_no` = `employee`.`employee_no` AND `employee`.`status` = '1'";
    let obj = { cmd: 'getList', query: query };

    this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
      .subscribe(data => {
        this.applicationConstants.appComp.hideBusyCursor();

        this.employee_list = data.data['list'];
        this.employee_list.unshift({ 'employee_no': '0', 'name': 'الكل', 'name_en': 'All' });
      });
  }

  search() {
    let obj = {
      cmd: 'getCashAcctList', employee_no: this.model['employee_no'],
      acct_number: this.model['acct_number']
    };

    this.utils.invokeHttp(this.applicationConstants.functionFile, obj)
      .subscribe(data => {
        this.applicationConstants.appComp.hideBusyCursor();

        this.dp = data.status['msg'];
        this.dataSource = new MatTableDataSource(this.dp);
        this.dataSource.sort = this.sort;
      });
  }

  print() {
    let html_data = '';
    let form = (document.getElementById('form1') as HTMLFormElement);

    html_data = '<table cellpadding="8" cellspacing="0"><tr>';
    html_data += '<td width="50%"> ' + this.Casher_Owner + ': ';
    if (this.model['employee_no'] != '') {
      for (let i = 0; i < this.employee_list.length; i++) {
        if (this.employee_list[i]['employee_no'] == this.model['employee_no']) {
          html_data += this.employee_list[i]['name']
          break;
        }
      }
    }
    html_data += '</td>';
    html_data += '<td width="50%"> ' + this.Acct_No + ': ' + this.model['acct_number'] + ' </td></tr>';
    html_data += '</table>';

    let table = (document.getElementById('cash_table2') as HTMLTableElement);
    html_data += this.utils.printReport(html_data, [{ table: table }], form, 'PDF');
  }

  exportToExcel() {
    this.utils.exportToExcel(this.table.nativeElement, this.model.title);
  }

}
